import * as React from 'react';

import { PropertyStructureDetailsViewModel } from 'models';

interface PropertyStructureDetailsProps {
  propertyStructureDetails?: PropertyStructureDetailsViewModel;
}

export const PropertyStructureDetails: React.FunctionComponent<PropertyStructureDetailsProps> = ({ propertyStructureDetails }) =>
  Boolean(propertyStructureDetails) &&
  Boolean(propertyStructureDetails.body) && (
    <div className="all-x-padding-three all-b-padding-six uitk-card-separator-bottom" data-stid="property-structure-type-details">
      <h4 className="property-structure-type-title uitk-type-500 uitk-type-bold">{propertyStructureDetails.title}</h4>
      <p className="uitk-type-paragraph-300">{propertyStructureDetails.body}</p>
    </div>
  );
